// Product version + crypto suite, injected at build time from the repo-root
// version.json (see vite.config.js `define`). Falls back to 'dev' in odd builds.
/* global __KM_VERSION__, __KM_SUITE__ */
export const APP_VERSION = typeof __KM_VERSION__ !== 'undefined' ? __KM_VERSION__ : 'dev';
export const CRYPTO_SUITE = typeof __KM_SUITE__ !== 'undefined' ? __KM_SUITE__ : '';
